import { Component, OnInit } from '@angular/core';
import { MobileWebViewService } from '@mpt-fo/common/core/services/mobile-web-view.service';
import { AuthenticationService } from '@mpt-fo/common/core/services/authentication.service';
import { DialogMessageType } from "@mpt-fo/common/shared/models/utility.model";
import { DelegateType } from '@mpt-fo/common/shared/models/utility.model';
import { GeneralService } from '@mpt-fo/common/core/services/general.service';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { MobileDelegateService } from '@mpt-fo/common/core/services/mobile-delegate.service';
import { LoginHelperService } from '@mpt-fo/common/core/services/login-helper.service';
import { DeviceHelperService } from '@mpt-fo/common/core/services/device-helper.service';
import {
	DEFAULT_DIALOG_CLASSES,
	DEFAULT_MODAL_KAMONA_CLASSES,
	DEFAULT_MODAL_WIDTH,
	MONIEPOINT_DESIGN_TYPE,
} from '@mpt-fo/common/shared/constants';
import { ErrorCode } from '@app/channels/onboarding/onboarding-v2/model/onboarding-v2-model';
import { IdentityProvider, OtpResentMode } from '@mpt-fo/common/kamona/model/kamonal-model';
import { Authentication2FAMixpanelSteps, AuthenticationEvents, DataLayerService } from '@mpt-fo/common/core/services/data-layer-service.service';
import { SettingsService } from '@mpt-fo/common/core/services/settings.service';
import { OnboardingV2Service } from '@mpt-fo/common/core/services/onboarding-v2.service';
import { AuthenticationType2FA } from '@mpt-fo/common/shared/models/authentication-method.enum';
import { TwoFactorAuthenticationOtpValidateResponse, TwoFactorAuthenticationStartResponse } from '@mpt-fo/common/shared/models/two-factor-authentication.model';
import { logger } from '@mpt-fo/common/telemetry';
import { Otp, TwoFactorGenerationPayload } from '@mpt-fo/common/shared/models/otp.model';
import { StringHelper } from '@mpt-fo/common/core/helpers/strings.helper';
import { AuthenticationType } from '@app/channels/settings/profile/components/authentication-methods/authentication-method/models/authentication-method.enum';
import { AppConfig } from '@mpt-fo/common/shared/config/app-config';
import { ProfileSetupService } from '@mpt-fo/common/core/services/profile-setup/profile-setup.service';
import { ClusterManagerManagementService } from '@mpt-fo/common/core/services/cluster-manager-management/cluster-manager-management.service';
import { LocationHelper } from '@mpt-fo/common/core/helpers/location.helper';
import { LivelinessErrorCode } from '@mpt-fo/common/core/services/liveliness.service';

@Component({
	selector: 'app-link-user-mobile-device',
	templateUrl: './link-user-to-mobile-device.component.html',
	styleUrls: ['./link-user-to-mobile-device.component.scss'],
})
export class LinkUserToMobileDeviceComponent implements OnInit {
	deviceRegistrationParameters: any;
	submitting: boolean;
	title: string;
	description: string;
	messageType: DialogMessageType;
	buttonName: string;
	resData: any;
	userRole: string;
	currentView = 0;
	businesses: any[] = [];
	runningModal: NzModalRef;
	firebaseToken: string;
	useOtp = false;
	livelinessCheckReference = '';
	identityProvider = IdentityProvider.METAMAP;
	readonly feature = 'DEVICE_REGISTRATION';
  verificationMethod: any;
  twoFactorOrder = [];
  twoOrderByLiveliness = false;
  validationKey = "";
  loading = false;
  PHONE_NUMBER_LOGIN_TYPE = 'PHONENUMBER';
  otp = "";
  isLivelinessVerificationDone = false;
  useNewDesignOtpWhatsappUssdDeviceRegistration = false;
  confirmingOtp = false;
  currentOtpModes = OtpResentMode;
  useResendOtpViaWhatsapp: boolean;
  useResendOtpViaSms: boolean;
  showBothCountDown = false;
  canUseNewUssd: boolean;
  currentOTPMode: OtpResentMode;
	constructor(
		private mobileService: MobileWebViewService,
		private authService: AuthenticationService,
		private generalService: GeneralService,
		private modalService: ModalService,
		private delegateService: MobileDelegateService,
		private loginHelper: LoginHelperService,
		private deviceHelper: DeviceHelperService,
		private dataLayerService: DataLayerService,
    private settingsService : SettingsService,
    private modalHelperService : OnboardingV2Service,
    private clusterManagerService: ClusterManagerManagementService,
    public config: AppConfig,
    private profileSetupService: ProfileSetupService,
    private locationHelper: LocationHelper,
	) {}

	ngOnInit(): void {
		this.deviceRegistrationParameters = this.mobileService.getDeviceRegistrationParameters();
		if (!this.deviceRegistrationParameters) {
			this.logout();
			return;
		}
    this.setOtpConfig();
    if (this.is2FAEnabled) {
      const response = this.deviceRegistrationParameters?.otpResponse?.responseData;
      this.handleRegistringDeviceResponse(response)
      return;
    }
		this.livelinessCheckReference = this.deviceRegistrationParameters.otpResponse.reference || '';
		this.useOtp = this.deviceRegistrationParameters.otpResponse.code !== ErrorCode.LIVELINESS_REQUIRED;
    this.verificationMethod = this.useOtp ? AuthenticationType.OTP : AuthenticationType.FACE_MATCH_CHECK;
		if (!this.useOtp) {
			this.identityProvider = this.deviceRegistrationParameters.otpResponse.provider || IdentityProvider.METAMAP;
		}
    const step = this.useOtp ? Authentication2FAMixpanelSteps.VALIDATE_OTP_STARTED : Authentication2FAMixpanelSteps.VALIDATE_FACE_MATCH_STARTED;
		this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, step));
	}

  setOtpConfig(){
    const whatsAppConfig = this.config.USE_OTP_WHATSAPP_DEVICE_REGISTRATION;
    this.useNewDesignOtpWhatsappUssdDeviceRegistration = this.config.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION;
    this.useResendOtpViaWhatsapp = whatsAppConfig;
    this.useResendOtpViaSms = this.isSmsEnabled;
	  this.canUseNewUssd = false; //this.profileSetupService.canUseNewUssd();
    this.showBothCountDown = this.useResendOtpViaWhatsapp && this.isSmsEnabled;
    if(!this.is2FAEnabled && this.useResendOtpViaWhatsapp){
      this.setOtpModeWhatsapp();
    }
  }

  get isSmsEnabled() {
    return this.config.SEND_SMS_OTP_2FA;
  }

  async getEventData(errorDetails?: { errorCode?: string; errorMessage: string; }, step= '') {
    const geoHeaders = await this.locationHelper.getCoordinates();

		return {
			auth_type: this.verificationMethod,
			auth_type_provider: this.getAuthTypeProvider(),
			feature: this.feature,
      step: step,
      ...(geoHeaders ? {
				longitude: geoHeaders.longitude,
				latitude: geoHeaders.latitude,
			} : {}),
			...(errorDetails ? {
				api_error_code: errorDetails.errorCode,
				api_error_message: errorDetails.errorMessage,
				error_message: errorDetails.errorMessage,
			} : {}),
		};
	}

  getAuthTypeProvider() {
    if (!this.isLivelinessVerificationDone) {
      return (this.verificationMethod === AuthenticationType2FA.OTP ? AuthenticationType2FA.OTP : this.identityProvider)
    }
    return '';
  }

  set2FAParams() {
    return {otpValidationKey: this.validationKey, reference: this.livelinessCheckReference}
  }

  setOtpParams(otp, reference) {
    if (this.useOtp) {
      return { otp }
    } else {
      return { reference }
    }
  }

	buildActivationDeviceObj(otp, reference) {
		const deviceInformation = this.deviceHelper.getDeviceInformation();
		const params: { businessId?: string, refreshToken?: string } = {};
		if(this.loginHelper.isNewStaffLogin() && this.loginHelper.staffUserTokenData() && this.loginHelper.staffUserTokenData().businesses?.length > 0){
			params.businessId = this.loginHelper.staffUserTokenData().businesses[0].businessId;
			params.refreshToken = this.loginHelper.staffUserTokenData().tokenData?.refresh_token;
		}
    if (!this.config.REMOVE_REFRESH_TOKEN_FOR_CM) {
      const clusterManagerTokenData = this.clusterManagerService.tokenDataDeviceResponse;
      if(this.clusterManagerService.isNewClusterManagerLogin() && clusterManagerTokenData) {
        params.refreshToken = clusterManagerTokenData.tokenData?.refresh_token;
      }
    }

    const otpReferencePyaload = this.is2FAEnabled ? this.set2FAParams() : this.setOtpParams(otp, reference);
		return {
			activationToken: this.deviceRegistrationParameters?.identifier,
			channel: 'MOBILE',
			deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier,
			identifier: this.deviceRegistrationParameters?.identifier,
			...(otpReferencePyaload),
			password: this.deviceRegistrationParameters?.password,
			username: this.deviceRegistrationParameters?.username,
			loginType: this.deviceRegistrationParameters?.loginType,
			...params
		};
	}

	setLoggedInUser(username) {
		this.delegateService
			.setDelegateData(DelegateType.setLoggedInUser, username)
			.then(() => {
				this.mobileService.setSavedUsername(username);
			})
			.catch((error) => {
				console.log('error from setLoggedInUser', error);
			});
	}

	submit(otp) {
		this.submitting = true;
		const params = this.buildActivationDeviceObj(otp.toString(), this.livelinessCheckReference);
    const apiCall = this.is2FAEnabled ? this.authService.activateDeviceOnLoginV2(params) : this.authService.activateDeviceOnLogin(params);
		apiCall
			.then((res) => {
				if (this.useOtp) {
					this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.DEVICE_ACTIVATION_SUCCESS));
				}
				this.resData = res;
				if (this.mobileService.isMobileWebViewUser()) {
					this.setLoggedInUser(params?.username);
				}
				this.launchFullAlertModal({
					title: 'Device Registration Successful',
					description: 'Device Registration Successful',
					alertType: 'success',
					callbackName: 'Continue',
				});
				this.submitting = false;
			})
			.catch((err) => {
				this.submitting = false;

        if (err?.error?.responseCode === ErrorCode.CLUSTER_MANAGER_USER_LOGIN) {
          this.loginHelper.saveClusterManagerUserTokenData(
            (this.clusterManagerService.isClusterManagerUser(err) ? err?.error.tokenDataDeviceResponse : err?.error),
            err?.error?.code === ErrorCode.CLUSTER_MANAGER_USER_LOGIN
          );
          return;
        }

				if (this.useOtp) {
					this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
						errorCode: err?.error?.responseCode,
						errorMessage: err.error?.description,
					}, Authentication2FAMixpanelSteps.DEVICE_ACTIVATION_FAILED));
				}
				const restartProcess = err?.error?.responseCode === LivelinessErrorCode.LIVELINESS_REFERENCE_CONSUMED;
				this.launchAlertModal({
					title: 'Device Registration Failed',
					description: err.error?.description || 'An Error occurred',
					callbackName: restartProcess ? 'Restart' : 'Close',
					callback: () => this.logout(),
				});
			});
	}

	launchAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = 'error';
		config.nzComponentParams.title = params?.title;
		config.className = DEFAULT_MODAL_KAMONA_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.callback = params?.callback;
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.alert(config);
	}

	launchFullAlertModal(params) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.alertType = params?.alertType;
		config.nzComponentParams.canShowLoading = true;
		config.nzComponentParams.title = params?.title;
		config.className = DEFAULT_DIALOG_CLASSES;
		config.nzWidth = DEFAULT_MODAL_WIDTH;
		config.nzComponentParams.callback = () => {
			this.onCloseMessage(this.resData);
		};
		config.nzComponentParams.designType = MONIEPOINT_DESIGN_TYPE.KAMONA;
		config.nzComponentParams.expiryTime = params?.expiryTime;
		config.nzComponentParams.callbackName = params?.callbackName || 'Close';
		config.nzComponentParams.message = params?.description;
		this.runningModal = this.modalService.newalert(config);
	}

	onCloseMessage($event: any) {
		if ($event) {
			this.submitting = true;
			this.setUserSession();
		} else {
			this.logout();
		}
	}

	logout() {
		this.generalService.logout();
		this.closeModal();
		this.submitting = false;
	}

	closeModal() {
		try {
			this.runningModal.destroy();
		} catch (error) {}
	}

	getDeviceInformation(){
		return this.deviceHelper.getDeviceInformation();
	}

	private setUserSession() {
		if(this.loginHelper.isNewStaffLogin() && this.resData.businesses){
			this.loginHelper.setStaffBusinesses(this.resData.businesses);
		}
		this.loginHelper.processSessionUser(this.resData, this.getDeviceInformation());
		this.submitting = false;
	}

	livelinessStepCompleted($evt) {
		if ($evt === -1) {
			this.logout();
			return;
		}
    this.isLivelinessVerificationDone = true;
    if (this.is2FAEnabled) {
      this.handle2FAFlow();
    } else {
      this.submit('');
    }
	}


  isTwoFactorAuthentication(): boolean {
    return this.verificationMethod === AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION;
  }

  activateDeviceV2(otp: string){
    this.otp = otp;
    if(this.is2FAEnabled){
      this.validateOtp2FA({otp : this.otp});
    } else {
      this.submit(this.otp);
    }
  }
  activateDeviceV3(event){
    this.activateDeviceV2(event?.otp);
  }

  handleOtpResponse(event) {
    this.validateOtp2FA(event);
  }

  async validateOtp2FA($event: Otp) {
    this.submitting = true;
    let payload = this.buildValidateOtpPayload($event?.otp);
    payload = {...payload, authenticationPurpose: this.feature};
    try {
      this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_STARTED));
      const res = await this.settingsService.ValidateOtp2FA(payload);
      this.handleOtpValidationSuccess(res);
      this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.VALIDATE_OTP_SUCCESS));
    } catch (error) {
      this.submitting = false;
      this.handleOtpValidationError(error);
      this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
        errorCode: error?.error?.code,
        errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
      }, Authentication2FAMixpanelSteps.VALIDATE_OTP_FAILED));
    }
  }

  buildValidateOtpPayload(otp: string){
		let payload = this.buildPayload();
		payload = {...payload, otp};
		return payload;
	}

  handleOtpValidationError(error) {
    logger.error('error on calling validating otp', error);
    this.showError(error);
  }

  handleOtpValidationSuccess(res: TwoFactorAuthenticationOtpValidateResponse) {
    this.validationKey = res?.validationKey;

    if (this.isTwoFactorAuthentication()) {
      this.handleTwoFactorAuthentication();
    } else {
      this.submit(this.otp);
    }
  }

  handleTwoFactorAuthentication() {
    if (!this.twoOrderByLiveliness) {
      this.generateReferenceAndSetLivenessStep();
    } else {
      this.submit(this.otp);
    }
  }

  generateReferenceAndSetLivenessStep() {
    this.generateReference2FA();
    this.useOtp = false;
  }

  handle2FAFlow() {
    if (this.isTwoFactorAuthentication() && this.twoOrderByLiveliness) {
      this.setCurrentStepToOTP();
      this.useOtp = true;
    } else {
      this.submit(this.otp);
    }
  }

  setCurrentStepToOTP() {
    this.generateOTP2FA();
  }

  buildPayload(): TwoFactorGenerationPayload{
    const userTypePayload = this.settingsService.getUserTypePayload();
	  const usePhoneNumberForRecovery = this.isPhoneNumberLoginType(userTypePayload);
    const value = userTypePayload?.value;
    const payload = usePhoneNumberForRecovery ? {phoneNumber: value} : {username: value};

    return {...payload, authenticationPurpose: this.feature};
  }

  buildPayload2FA(){
    const userTypePayload = this.settingsService.getUserTypePayload();
	  const usePhoneNumberForRecovery = this.isPhoneNumberLoginType(userTypePayload);
    const value = userTypePayload?.value;
    const payload = usePhoneNumberForRecovery ? {mobileNumber: value} : {username: value};

    return {...payload, authenticationPurpose: this.feature};
  }

  isPhoneNumberLoginType(userTypePayload){
	  return userTypePayload?.identityType === this.PHONE_NUMBER_LOGIN_TYPE;
  }


  setOtpModeWhatsapp(){
    if(this.useResendOtpViaWhatsapp && !this.useResendOtpViaSms){
      this.currentOTPMode = OtpResentMode.WHATSAPP_MODE;
    }
  }

  async generateOTP2FA() {
    this.loading = true;
    this.useOtp = true;
    try {
      this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.GENERATE_OTP_STARTED));
      const payload = this.buildPayload2FA();
      payload['notificationChannel'] = (this.currentOTPMode || OtpResentMode.SMS_MODE)?.split('_')[0];
      const res = await this.settingsService.generateOtp2FAPublic(payload, this.feature);
      this.deviceRegistrationParameters.ussdCode = res?.ussdCode;
      this.setOtpModeWhatsapp();
      this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.GENERATE_OTP_SUCCESS));
    } catch (error) {
      this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
        errorCode: error?.error?.code,
        errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
      }, Authentication2FAMixpanelSteps.GENERATE_OTP_FAILED));
      logger.error('error on calling generate otp', error);
      this.showError(error);
    } finally {
      this.loading = false;
    }
  }


  handleRegistringDeviceResponse(res: TwoFactorAuthenticationStartResponse){
    this.verificationMethod = res.authenticationMethod;
    if(this.verificationMethod !== AuthenticationType2FA.TWO_FACTOR_AUTHENTICATION){
      this.twoFactorOrder = [res.authenticationMethod]
    } else {
      this.twoFactorOrder = res.order;
    }
    this.setSteps(res);
	}

  setSteps(res: TwoFactorAuthenticationStartResponse) {
    this.twoOrderByLiveliness = res.order ? res.order[0] == AuthenticationType2FA.FACE_MATCH : false;
    if (this.is2FAEnabled) {
      this.generate2FA();
    }
  }

  async generate2FA() {
    this.submitting = true;

    try {
      await this.processTwoFactorMethods();
    } catch (error) {
      this.handle2FAError(error);
    } finally {
      this.submitting = false;
    }
  }

  async processTwoFactorMethods() {
    for (const method of this.twoFactorOrder) {
      if (await this.shouldGenerateReference2FA(method)) {
        await this.generateReference2FA();
        break;
      } else if (await this.shouldGenerateOTP2FA(method)) {
        await this.generateOTP2FA();
        break;
      }
    }
  }

  async generateReference2FA() {
    this.loading = true;
    const payload = this.buildPayload2FA();
    const deviceInformation = this.getDeviceInformation();

    this.dataLayerService.logEventWithData(AuthenticationEvents.initiated, this.getEventData(null, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_STARTED));
    this.settingsService.generateReference2FA(
      {
        ...payload, 
        deviceUniqueIdentifier: deviceInformation?.deviceUniqueIdentifier
      }
    )
      .then((res) => {
        this.livelinessCheckReference = res.reference;
        this.identityProvider = res.provider;
        this.useOtp = false;
        this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getEventData(null, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_SUCCESS));
      }
      )
      .catch((error) => {
        this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
          errorCode: error?.error?.code,
          errorMessage: StringHelper.getErrorMessageHttpErrorResponse(error),
        }, Authentication2FAMixpanelSteps.INITIATE_FACE_MATCH_FAILED));
        logger.error('error on calling generate liveliness referrence', error);
        this.showError(error);
      })
      .finally(() => {
        this.loading = false;
        this.submitting = false;
      });
  }

  async shouldGenerateReference2FA(method) {
    return method === AuthenticationType2FA.FACE_MATCH && !this.livelinessCheckReference;
  }

  async shouldGenerateOTP2FA(method) {
    return method === AuthenticationType2FA.OTP && !this.deviceRegistrationParameters.ussdCode;
  }

  handle2FAError(error) {
    logger.error('catching error on generate 2fa', error);
    this.showError(error);
  }

  showError(error) {
	  const params = this.getErrorParameters(error);
	  this.launchFailedModal(params?.description, params?.title, params?.callbackName);
  }

  get is2FAEnabled(){
    return this.deviceRegistrationParameters?.otpResponse?.responseCode == ErrorCode.TWO_FACTOR_AUTHENTICATION;
  }

  getErrorParameters(error) {
    const title = this.getFailedOtpGenerationTitle(error);
    const callbackName = this.getFailedOtpGenerationCallbackName(error);
    const description = StringHelper.getErrorMessageHttpErrorResponse(error);
    return { title, callbackName, description };
  }
  getFailedOtpGenerationTitle(error: any) {
    const title = this.modalHelperService.isSuspended(error) ?
      'Temporary Suspension' : ''
    return title;
  }

  getFailedOtpGenerationCallbackName(error: any) {
    const callbackName = this.modalHelperService.isSuspended(error) ? 'Dismiss' : ''
    return callbackName;
  }

  launchFailedModal(description, title, callbackName) {
    this.modalHelperService.launchErrorModalV2({ description, callbackName, title })
      .then(() => {
        this.modalHelperService.closeModal();
      });
  }

  reloadOtp(currentMode: OtpResentMode) {
    this.currentOTPMode = currentMode;
    const isUssdResend = currentMode === OtpResentMode.USSD_MODE;
    isUssdResend ? this.handleResendOtpViaUssd()
      : this.generateOTP2FA();
  }

  handleResendOtpViaUssd() {
    this.setConfirmingOtp(true);
  }

  setConfirmingOtp(value: boolean) {
    this.confirmingOtp = value;
  }

  goBack() {
		this.generalService.logout();
	}
}
